module.exports = __webpack_public_path__ + "img/node.js-logo.521444a2.png";